import React from "react";

import styles from "./DiscountInputField.module.css"
import {CustomSmallInputField} from "../customSmallInputField/CustomSmallInputField";
import {SubtractSwitcher} from "../subtractSwitcher/SubtractSwitcher";
import {SubtractionType} from "../../../api/generated";

interface FieldProps {
    type?: string
    disabled?: boolean
    value?: number
    setValue: (value: number) => void
    subtractionType: SubtractionType
    onSubtractionChange: (value: SubtractionType) => void
    placeholder?: string
    errorMessage?: string
    title?: string
}


export const DiscountInputField: React.FC<FieldProps> = ({
                                                             type,
                                                             disabled,
                                                             value,
                                                             setValue,
                                                             placeholder,
                                                             errorMessage,
                                                             subtractionType,
                                                             onSubtractionChange,
                                                             title = "Discount"
                                                         }) => {

    return <div className={styles.wrapper}>
        <span className={styles.title}>{title}</span>
        <div className={styles.fields}>
            <CustomSmallInputField
                type={type}
                value={value}
                setValue={setValue}
                disabled={disabled}
                placeholder={placeholder}
                errorMessage={errorMessage}
                subtractionType={subtractionType}
            />
            <SubtractSwitcher subtractionType={subtractionType} setSubtractionType={onSubtractionChange}/>
        </div>
    </div>
}
